import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import SelectField from '../../../../ui/customSelect/select';
const Index = ({ FORM_FIELD_SPECS, selectedSearchType, searchParams, errors, register }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <CardContent className="space-y-2 lg:pr-0" key={`key_${selectedSearchType}`}>
      <div className="flex">
        <SelectField
          classname="w-full text-base font-normal"
          id={FORM_FIELD_SPECS?.queueName?.id}
          register={register}
          errors={errors}
          options={FORM_FIELD_SPECS?.queueName?.options}
          rules={{
            required: Texts?.orderQueuesRequired,
          }}
          placeHolder={Texts?.orderQueuesSelect}
          defaultValue={searchParams?.queueName}
        />
        <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-lg font-semibold text-white" type="submit">
          {Texts?.searchButtonText}
        </Button>
      </div>
    </CardContent>
  );
};

export default Index;
